module.exports = "/assets/c9b94a1d0cef8f87d7e56214fde69d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NZ.png
// module id = 1664
// module chunks = 0